export const stringsKey = "UserPermissions";
export const englishStrings = {
	searchPlaceholder: "Search Email",
	addButtonTooltip: "Add",
	userHeader: "User",
	permissionsHeader: "Permissions",
	actionsHeader: "Actions",
	errorMessage: "Error occurred retrieving user roles",
	dialogueApiError: "An error occurred when communicating with the server",
	dialogueInvalidData: "The data entered is invalid",
	dialogueAddTitle: "Add new permissions",
	dialogueDeleteTitle: "Delete permissions for ",
	dialogueEditTitle: "Edit permissions for ",
	dialogueErrorTitle: "Error",
	dialogueErrorContent: "An error has occurred",
	dialogueEmailLabel: "Email Address",
	dialogueCountryLabel: "Country",
	dialogueRoleLabel: "Role",
	dialogueDeleteWarning:
		"This will delete all roles for this user. Are you sure you wish to proceed?",
	dialogueSubmitButton: "Submit",
	dialogueConfirmButton: "Confirm",
	dialogueSaveButton: "Save",
	dialogueCloseButton: "Close",
};
